import { __awaiter, __generator } from "tslib";
import React, { useState } from "react";
import Modal from "@adsk/alloy-react-modal";
import Button, { LinkButton } from "@adsk/alloy-react-button";
import { BannerError, SubmitError, TemplateCreateType, } from "../shared/types";
import { DuplicateNameError, InvalidNameError, NameTooLongError, } from "../shared/errors";
import { useTranslations } from "../utils/useTranslations";
import { CreateTemplateGlobalTemplateModalInputModal } from "./CreateTemplateFromGlobalTemplateInput/CreateTemplateFromGlobalTemplateInput";
import { AnalyticsEvents } from "../shared/constants";
import { ErrorBannerProjectCreate } from "../shared/SharedDataInputModal.styles";
import { BANNER_VARIANTS } from "@adsk/alloy-react-banner";
import { CancelConfirmation } from "../shared/components/CancelConfirmation";
import { FooterButton, ModalBody, ModalComponent, } from "../shared/SharedCreateTemplateModal.styles";
import { useToasts } from "./hooks/useToasts";
export var CreateTemplateFromGlobalTemplateModal = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, globalTemplateProject = _a.project, onSubmitProvided = _a.onSubmit, track = _a.track;
    var T = useTranslations().T;
    var _c = useToasts(), showInfoToast = _c.showInfoToast, showSuccessToast = _c.showSuccessToast, showErrorToast = _c.showErrorToast;
    // Confirmation Modal
    var _d = useState(false), isOpenConfirmationModal = _d[0], setIsOpenConfirmationModal = _d[1];
    // Input Data
    var _e = useState(""), templateNameInput = _e[0], setTemplateNameInput = _e[1];
    // Submit
    // Error
    var _f = useState({
        isOpen: false,
        bannerError: undefined,
        submitError: undefined,
    }), submitErrorData = _f[0], setSubmitErrorData = _f[1];
    var errorHandler = function (submitError, analytic, bannerError) {
        if (bannerError === void 0) { bannerError = BannerError.Name; }
        setSubmitErrorData({
            isOpen: true,
            bannerError: bannerError,
            submitError: submitError,
        });
        track && track(analytic);
    };
    var submitErrorHandlers = (_b = {},
        _b[DuplicateNameError.name] = function () {
            return errorHandler(SubmitError.DuplicateName, AnalyticsEvents.createTemplateGlobalTemplateModal.submit
                .duplicateNameError);
        },
        _b[InvalidNameError.name] = function () {
            return errorHandler(SubmitError.InvalidName, AnalyticsEvents.createTemplateGlobalTemplateModal.submit
                .invalidNameError);
        },
        _b[NameTooLongError.name] = function () {
            return errorHandler(SubmitError.NameTooLong, AnalyticsEvents.createTemplateGlobalTemplateModal.submit
                .nameTooLongError);
        },
        _b);
    // Process
    var _g = useState(false), isSubmitting = _g[0], setIsSubmitting = _g[1];
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var createTemplateData, error_1, errorName, currentErrorHandler;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSubmitting(true);
                    createTemplateData = {
                        name: templateNameInput,
                        accountId: globalTemplateProject.accountId,
                        type: TemplateCreateType.FromProject,
                        projectId: globalTemplateProject.id,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    showInfoToast(T.translate("createTemplateModal.saveAsTemplateFromGlobalTemplateInfo", {
                        templateName: templateNameInput,
                    }));
                    return [4 /*yield*/, onSubmitProvided(createTemplateData)];
                case 2:
                    _a.sent();
                    track &&
                        track(AnalyticsEvents.createTemplateGlobalTemplateModal.submit.success);
                    if (!(submitErrorData === null || submitErrorData === void 0 ? void 0 : submitErrorData.isOpen))
                        showSuccessToast(T.translate("createTemplateModal.saveAsTemplateFromGlobalTemplateSuccess", {
                            templateName: templateNameInput,
                        }));
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    errorName = error_1.constructor.name;
                    currentErrorHandler = submitErrorHandlers[errorName];
                    if (!currentErrorHandler)
                        currentErrorHandler = function () {
                            return errorHandler(SubmitError.Other, AnalyticsEvents.createTemplateGlobalTemplateModal.submit.otherError, BannerError.Other);
                        };
                    currentErrorHandler();
                    showErrorToast(T.translate("createTemplateModal.saveAsTemplateFromGlobalTemplateFail"));
                    return [3 /*break*/, 5];
                case 4:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (!open)
        return null;
    var closeModal = function () {
        if (templateNameInput) {
            setIsOpenConfirmationModal(true);
        }
        else {
            onClose();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(CancelConfirmation, { open: open && isOpenConfirmationModal, onClose: function () { return setIsOpenConfirmationModal(false); }, onConfirm: function () {
                setIsOpenConfirmationModal(false);
                onClose();
            } }),
        React.createElement(ModalComponent, { "data-testid": "CreateTemplateFromGlobalTemplateModal", open: open, onClose: closeModal },
            React.createElement(Modal.Header, { "data-testid": "CreateTemplateFromGlobalTemplateModal.Header" },
                T.translate("createTemplateModal.saveAsTemplateFromGlobalTemplateTitle"),
                React.createElement(Modal.Close, { "data-testid": "CreateTemplateFromGlobalTemplateModal.CloseButton", onClick: function () {
                        track &&
                            track(AnalyticsEvents.createTemplateGlobalTemplateModal
                                .closeModalFromHeader);
                        closeModal();
                    } })),
            React.createElement(ModalBody, { "data-testid": "CreateTemplateFromGlobalTemplateModal.Body" },
                (submitErrorData === null || submitErrorData === void 0 ? void 0 : submitErrorData.isOpen) && (React.createElement(ErrorBannerProjectCreate, { "data-testid": "CreateTemplateFromGlobalTemplateModal.Banner.Error", message: T.translate(submitErrorData.bannerError === BannerError.Name
                        ? "creationErrors.name"
                        : "creationErrors.other"), variant: BANNER_VARIANTS.ERROR, open: submitErrorData === null || submitErrorData === void 0 ? void 0 : submitErrorData.isOpen, inline: true, onClose: function () {
                        setSubmitErrorData({
                            isOpen: false,
                            bannerError: undefined,
                            submitError: undefined,
                        });
                    } })),
                React.createElement("span", null, T.translate("createTemplateModal.saveAsTemplateFromGlobalTemplate", {
                    templateName: globalTemplateProject.name,
                })),
                React.createElement(CreateTemplateGlobalTemplateModalInputModal, { isSubmitting: isSubmitting, name: templateNameInput, onNameChange: function (inputData) {
                        setTemplateNameInput(inputData);
                        if (submitErrorData === null || submitErrorData === void 0 ? void 0 : submitErrorData.submitError)
                            setSubmitErrorData({
                                isOpen: false,
                                bannerError: undefined,
                                submitError: undefined,
                            });
                    }, submitError: submitErrorData === null || submitErrorData === void 0 ? void 0 : submitErrorData.submitError })),
            React.createElement(Modal.Footer, null,
                React.createElement(FooterButton, null,
                    React.createElement(LinkButton, { "data-testid": "CreateTemplateFromGlobalTemplateModal.Footer.CancelButton", onClick: function () {
                            closeModal();
                            track &&
                                track(AnalyticsEvents.createTemplateGlobalTemplateModal
                                    .cancelButton);
                        } }, T.translate("navigation.cancel"))),
                React.createElement(Button, { "data-testid": "CreateTemplateFromGlobalTemplateModal.Footer.SubmitButton", variant: "primary", loading: isSubmitting, disabled: !templateNameInput.length ||
                        isSubmitting ||
                        !!(submitErrorData === null || submitErrorData === void 0 ? void 0 : submitErrorData.submitError), onClick: function () {
                        track &&
                            track(AnalyticsEvents.createTemplateGlobalTemplateModal
                                .submitButton);
                        onSubmit();
                    } }, T.translate("genericStrings.saveAsTemplate"))))));
};
